import React, { useState } from 'react';
import './WelcomeModal.css';

interface WelcomeModalProps {
  onSeed: () => Promise<void>;
  onDismiss: (dontShowAgain: boolean) => void;
  isSeeding: boolean;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ onSeed, onDismiss, isSeeding }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  return (
    <div className="modal-overlay">
      <div className="modal-content welcome-modal-content">
        <div className="welcome-modal-icon">🎒</div>
        <h2 className="welcome-modal-title">Welcome to Simple Packing!</h2>
        <p className="welcome-modal-description">
          Your gear inventory is empty. Would you like us to add sample data to help you
          get started? We'll create:
        </p>
        <ul className="welcome-modal-list">
          <li>~45 gear items across all categories</li>
          <li>4 ready-to-use templates (Backpacking, Car Camping, Ski Trip, Day Hike)</li>
        </ul>
        <p className="welcome-modal-description">
          You can edit or delete any of it later.
        </p>

        <div className="welcome-modal-actions">
          <button
            className="card-button primary"
            onClick={onSeed}
            disabled={isSeeding}
          >
            {isSeeding ? (
              <span className="welcome-modal-loading">
                <span className="welcome-modal-spinner" />
                Adding sample data...
              </span>
            ) : (
              'Yes, add sample data'
            )}
          </button>
          <button
            className="card-button"
            onClick={() => onDismiss(dontShowAgain)}
            disabled={isSeeding}
          >
            No thanks
          </button>
        </div>

        <label className="welcome-modal-checkbox-label">
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={e => setDontShowAgain(e.target.checked)}
            disabled={isSeeding}
          />
          Don't show this again
        </label>
      </div>
    </div>
  );
};

export default WelcomeModal;
